var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28148 7.16118L7.16016 9.2825L22.7165 24.8389L24.8378 22.7175L9.28148 7.16118Z",
    fill: "#F5DEB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8381 9.28248L22.7168 7.16116L7.16045 22.7175L9.28177 24.8388L24.8381 9.28248Z",
    fill: "#F5DEB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCloseIcon);
export default __webpack_public_path__ + "static/media/menuCloseIcon.ea71769843fa292317f8b06b4498709e.svg";
export { ForwardRef as ReactComponent };